/**
 * Delete – SVG icon.
 */
import ScreenUtils from '@screen';

interface Props {
  focused: boolean;
  width?: number;
  height?: number;
}

/** Delete / remove item. */
export default function DeleteIcon({
  focused,
  width = 33,
  height = 32,
}: Props) {
  return (
    <svg
      fill='none'
      width={width * ScreenUtils.widthRatio}
      height={height * ScreenUtils.widthRatio}
      xmlns='http://www.w3.org/2000/svg'
      viewBox={`0 0 ${width} ${height}`}
    >
      <path
        fill={focused ? 'black' : 'white'}
        d='M15.714 13.525a.75.75 0 1 1 1.061-1.06l2.475 2.474 2.475-2.475a.75.75 0 1 1 1.06 1.061L20.312 16l2.474 2.475a.75.75 0 1 1-1.06 1.06l-2.475-2.474-2.475 2.474a.75.75 0 1 1-1.06-1.06L18.188 16z'
      />
      <path
        fill={focused ? 'black' : 'white'}
        fillRule='evenodd'
        d='M12.621 8.379 5 16l7.621 7.621a3 3 0 0 0 2.122.879H25a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3H14.743a3 3 0 0 0-2.122.879M25 23.2H14.743a1.7 1.7 0 0 1-1.203-.498L6.84 16l6.701-6.702a1.7 1.7 0 0 1 1.203-.498H25a1.7 1.7 0 0 1 1.7 1.7v11a1.7 1.7 0 0 1-1.7 1.7'
        clipRule='evenodd'
      />
    </svg>
  );
}
